import React from "react";
import { useNavigate } from "react-router-dom";
import TeamsManagementWorkspace from "../../components/TeamsManagementWorkspace";
import api from "../../api/client";
import { useOrg } from "../../context/OrgContext";
import { useTerminology } from "../../context/TerminologyContext";

function pctClass(pct, yellow, red) {
  const p = Number(pct) || 0;
  if (p >= Number(red || 90)) return "usage-pct usage-pct-red";
  if (p >= Number(yellow || 70)) return "usage-pct usage-pct-yellow";
  return "usage-pct usage-pct-normal";
}

function AdminUsageSummary() {
  const { current: currentOrg } = useOrg();
  const { tp } = useTerminology();
  const navigate = useNavigate();
  const [status, setStatus] = React.useState(null);

  React.useEffect(() => {
    api
      .get("/usage/status")
      .then((r) => setStatus(r.data?.status || null))
      .catch(() => setStatus(null));
  }, [currentOrg]);

  if (!status) return null;
  const mode = String(status.quota_mode || "both").toLowerCase();
  const yellow = status.yellow_threshold_pct ?? 70;
  const red = status.red_threshold_pct ?? 90;
  const showM = mode === "monthly" || mode === "both";
  const showY = mode === "yearly" || mode === "both";

  return (
    <div className="section usage-status-card admin-usage-summary">
      <div className="page-header-row">
        <div>
          <h3>Workspace usage</h3>
          <div className="helper-text">
            Quick view of credit usage. Open the Usage Ledger to request more
            credits or audit every event.
          </div>
        </div>
        <div>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => navigate("/usage")}
          >
            Open Usage Ledger
          </button>
        </div>
      </div>
      <div className="usage-status-grid">
        {showM ? (
          <div className="usage-status-tile">
            <div className="usage-status-label">Monthly</div>
            <div className="usage-status-value">
              <strong>{status.monthly?.in_use ?? 0}</strong> /{" "}
              {status.monthly_limit ?? 0}
              <span
                className={pctClass(status.monthly?.percent_used, yellow, red)}
              >
                {Number(status.monthly?.percent_used || 0).toFixed(1)}%
              </span>
            </div>
            <div className="usage-status-detail">
              Used {status.monthly?.used ?? 0} • Reserved{" "}
              {status.monthly?.reserved ?? 0} • Available{" "}
              {status.monthly?.available ?? 0}
            </div>
          </div>
        ) : null}
        {showY ? (
          <div className="usage-status-tile">
            <div className="usage-status-label">Yearly</div>
            <div className="usage-status-value">
              <strong>{status.yearly?.in_use ?? 0}</strong> /{" "}
              {status.yearly_limit ?? 0}
              <span
                className={pctClass(status.yearly?.percent_used, yellow, red)}
              >
                {Number(status.yearly?.percent_used || 0).toFixed(1)}%
              </span>
            </div>
            <div className="usage-status-detail">
              Used {status.yearly?.used ?? 0} • Reserved{" "}
              {status.yearly?.reserved ?? 0} • Available{" "}
              {status.yearly?.available ?? 0}
            </div>
          </div>
        ) : null}
        <div className="usage-status-tile">
          <div className="usage-status-label">On hold</div>
          <div className="usage-status-value">
            <strong>{status.held_count ?? 0}</strong>
          </div>
          <div className="usage-status-detail">
            {tp("lot")} waiting for credits in this workspace
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AdminUsersPage() {
  return (
    <>
      <AdminUsageSummary />
      <TeamsManagementWorkspace
        title="Add & Manage Users"
        subtitle="Create and maintain users for this workspace."
        eyebrow="Admin"
        icon="users"
        showOrgTab={false}
      />
    </>
  );
}
